import { MdNavigateBefore, MdNavigateNext } from 'react-icons/md';

type Props = {
  page: number;
  setPage: any;
  pages: number;
  totalCount?: number;
  pageSize?: number;
};

export const Pagination = ({ page, setPage, pages }: Props) => {
  const getVisiblePages = () => {
    const visiblePages = [];
    let startPage = Math.max(1, page - 1);
    let endPage = Math.min(pages, page + 1);

    if (page === 1) {
      endPage = Math.min(pages, 3);
    } else if (page === pages) {
      startPage = Math.max(1, pages - 2);
    }

    for (let i = startPage; i <= endPage; i++) {
      visiblePages.push(i);
    }

    return visiblePages;
  };

  return (
    <div className='flex justify-between border-t border-stroke px-8 pt-5'>
      <p className='font-light'>
        Page {page} of {pages}
      </p>
      <div className='flex'>
        <button
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
          className='flex cursor-pointer items-center justify-center rounded-md p-1 px-2 hover:bg-primary'
        >
          <MdNavigateBefore size={20} />
        </button>

        {getVisiblePages().map((pageNum) => (
          <button
            key={pageNum}
            className={`mx-1 flex cursor-pointer items-center justify-center rounded-md p-1 px-3 ${
              pageNum === page ? 'bg-primary' : 'hover:bg-primary'
            }`}
            onClick={() => setPage(pageNum)}
          >
            {pageNum}
          </button>
        ))}
        <button
          onClick={() => setPage(page + 1)}
          disabled={page === pages}
          className='flex cursor-pointer items-center justify-center rounded-md p-1 px-2 hover:bg-primary'
        >
          <MdNavigateNext size={20} />
        </button>
      </div>
    </div>
  );
};
